import { useState } from 'react';

import RadioButton from '@rio-cloud/rio-uikit/RadioButton';

export type AnimationRadioOption<T extends string> = {
    value: T;
    label: string;
};

export type AnimationControlValue<T extends string> = T | '';

type AnimationRadioGroupProps<T extends string> = {
    name: string;
    value?: AnimationControlValue<T>;
    defaultValue?: AnimationControlValue<T>;
    options: readonly AnimationRadioOption<T>[];
    onChange?: (value: AnimationControlValue<T>) => void;
    className?: string;
};

export const AnimationRadioGroup = <T extends string>({
    name,
    value,
    defaultValue,
    options,
    onChange,
    className = 'display-flex justify-content-center',
}: AnimationRadioGroupProps<T>) => {
    const [uncontrolledValue, setUncontrolledValue] = useState<AnimationControlValue<T>>(defaultValue || '');
    const currentValue = value ?? uncontrolledValue;

    const handleChange = (nextValue: AnimationControlValue<T>) => {
        if (value === undefined) {
            setUncontrolledValue(nextValue);
        }

        onChange?.(nextValue);
    };

    return (
        <div className={className}>
            {options.map(option => (
                <RadioButton
                    key={option.value}
                    name={name}
                    onChange={() => handleChange(option.value)}
                    checked={currentValue === option.value}
                    inline
                >
                    {option.label}
                </RadioButton>
            ))}
        </div>
    );
};
